var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-info-field"},[_c('customer-input',{attrs:{"labelText":_vm.label,"value":_vm.personalInfoField.value,"has-error":!_vm.personalInfoField.isValid,"onInput":_vm.setPersonalInfo,"top-left-label":_vm.errorMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }